import BaseActions from "features/library/actions/library-actions/BaseActions";
import { useTranslation } from "react-i18next";
import { GenericButton } from "shared/ui-basics/index";
import { CustomBreadCrumb } from "shared/ui-basics/ui-components/CustomBreadCrumb";
import styled from "styled-components/macro";
import { useModal } from "use-modal-hook";
import { LibraryUploadFile } from "../../../modals/LibraryUploadFile";

interface CustomLibraryHeaderProps {
	library: any;
}

export const CustomLibraryHeader: React.FC<CustomLibraryHeaderProps> = ({ library }) => {
	const { t } = useTranslation();
	const actions = BaseActions({ library });
	const copyAction = actions?.find((act) => act?.id === "copy");
	const deleteAction = actions?.find((act) => act?.id === "delete");
	const [showImportModal] = useModal(LibraryUploadFile, {
		libraryId: library?.id,
	});
	return (
		<LibraryHeader>
			<CustomBreadCrumb paths={[t("LIBRARIES"), t(library?.name)]} />
			{library?.isCustom && (
				<HeaderActions>
					<GenericButton variant="light-link" tooltip tooltipText={t("DUPLICATE")} icon="COPY" onClick={copyAction?.handleClick} />
					<GenericButton variant="light-link" tooltip tooltipText={t("ASPX_13")} icon="DELETE" onClick={deleteAction?.handleClick} />
					<GenericButton variant="dark" tooltipText={t("ASPX_13")} icon="file-xls" iconClassName="me-2" onClick={showImportModal}>
						{t("IMPORT_ITEMS")}
					</GenericButton>
				</HeaderActions>
			)}
		</LibraryHeader>
	);
};

const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`;

const LibraryHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 16px;
	border-bottom: 1px solid #efefef;
`;
